import Swal from 'sweetalert2';

// `target` lets callers mount SwAl inside a specific element — required when the
// caller is inside a native <dialog> in the browser top layer (defaults to body otherwise).
const withTarget = (config, options) => (options && options.target ? { ...config, target: options.target } : config);

export default {
  loading: (options) => {
    Swal.close();
    Swal.fire(
      withTarget(
        {
          icon: 'info',
          title: options.title,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          // SweetAlert2 scrolls the page to the top when displaying an information modal.
          // We set heightAuto to false to prevent this, see: https://deepwiki.com/search/heightauto_3c8b4673-a03e-4aa3-8afc-d74b481fa8e8.
          heightAuto: false,
        },
        options
      )
    );
    Swal.showLoading();
  },
  success: (options) => {
    Swal.close();
    Swal.fire(
      withTarget(
        {
          icon: 'success',
          title: options.title,
          showConfirmButton: false,
          heightAuto: false,
        },
        options
      )
    );
    setTimeout(() => {
      Swal.close();
    }, 1500);
  },
  error: (options) => {
    Swal.close();
    Swal.fire(
      withTarget(
        {
          icon: 'error',
          title: options.title,
          text: options.text,
          confirmButtonText: 'Got it!',
          heightAuto: false,
        },
        options
      )
    );
  },
};
